import React from 'react';
import { FormattedMessage } from 'react-intl';

const DepositLinkMessage = () => (
    <FormattedMessage id="dc.dibs-buyer-deposit.DepositLinkMessage" defaultMessage="View details" />
);

export default DepositLinkMessage;
